import React from 'react';
import { useThemeContext, WizardContext } from '../../../context';
import { SelectList } from '../SelectList';
import { WizardButton } from '../../Shared/Wizard';
import { WizardActions } from '../../Shared/Styled';
import { SelectItem } from '../../../types';
import { ConnectionDefaultTabToggle } from '../ConnectionSelection';
import { User } from 'oidc-client';

export interface DefaultRouteSelectionProps {
  items: SelectItem[];
  selected?: string;
  tabIsDefault: boolean;
  tabConfigured: boolean;
  user?: User;
  setTabIsDefault: (value: boolean) => any;
}

export function DefaultRouteSelection({
  items,
  selected,
  tabIsDefault,
  tabConfigured,
  user,
  setTabIsDefault,
}: DefaultRouteSelectionProps) {
  const theme = useThemeContext();

  return (
    <WizardContext.Consumer>
      {({ goto }) => (
        <div
          id='DefaultRouteSelection'
          style={{
            display: 'inline-flex',
            width: '100%',
            flexDirection: 'column',
          }}
        >
          <SelectList
            items={items}
            selected={selected}
            label={'Default Content'}
            selectedProperty='value'
          />
          <ConnectionDefaultTabToggle
            tabIsDefault={tabIsDefault}
            setTabIsDefault={setTabIsDefault}
            isPw365Project={true}
            user={user}
            label="Set created tab as default for all project's connections"
          />
          <WizardActions>
            <WizardButton
              direction='back'
              label={'Project'}
              onClick={() => goto('choose-project')}
              theme={theme}
            />
            {!tabConfigured && (
              <WizardButton
                direction='forward'
                label='Tab Name'
                disabled={!selected}
                onClick={() => goto('enter-tab-name')}
                theme={theme}
              />
            )}
          </WizardActions>
        </div>
      )}
    </WizardContext.Consumer>
  );
}
